import type {State} from 'src/reducers';


export const selectCsrfToken = (state: State): string | null | undefined =>
  state.csrf?.token;
